<template>
  <div>

    <b-row>
      <b-col>
        <p>Get Dropsmart for a year + a full scholarship to the Essential Oil Empress Program (limited).</p>
        <p>When you commit to the Dropsmart System for a year, you receive a full scholarship to the Essential Oil Empress Program (EOE). EOE is a legacy training rarely opened and not available for standalone purchase. Your scholarship activates the moment you join Dropsmart yearly.</p>
        <p>Scholarships are limited. Available only this December.</p>
        <p>Once closed, it may not reopen.</p>

        <h2 style="margin-top: 20px;"><strong>What You'll Receive</strong></h2>
        <ul class="benefits">
          <li><strong>✅ Dropsmart — 12 Months Access</strong></li>
          <p>Your core professional aromatherapy system for clarity, precision, and confident decision-making. Dropsmart replaces guesswork with structure — instantly. Use it to:</p>
          <ul>
            <li>• Compare essential oils with precision</li>
            <li>• See therapeutic patterns in seconds</li>
            <li>• Make fast, grounded decisions</li>
            <li>• Avoid hours of unnecessary research</li>
            <li>• Work like a modern, forward-thinking aromatherapist</li>
          </ul>

          <li style="margin-top: 15px;"><strong>✅ Full Scholarship to the Essential Oil Empress™ Program (EOE)</strong></li>
          <p>EOE is the legacy program designed to transform the way you think, decide, and lead as an aromatherapist. It's rarely opened and no longer available for standalone enrollment, which is why this scholarship is such a meaningful opportunity. Your full scholarship activates the moment you join the Dropsmart yearly plan.</p>
          <p>Inside EOE, you'll learn how to:</p>
          <ul>
            <li>• Compare and interpret species and chemotypes with clarity</li>
            <li>• Remove common misunderstandings about chemistry and safety</li>
            <li>• Think beyond profiles and see predictable therapeutic patterns</li>
            <li>• Formulate with more confidence, elegance, and structure</li>
            <li>• Understand oils with 1, 3, or multiple dominant components</li>
            <li>• Teach aromatherapy with more clarity and credibility</li>
            <li>• Strengthen how you teach, explain, and practice aromatherapy</li>
          </ul>

          <li style="margin-top: 15px;"><strong>✅ Self-Paced Learning</strong></li>
          <p>Move through every lesson, replay, and exercise at your own rhythm without deadlines or pressure.</p>

          <li style="margin-top: 15px;"><strong>✅ Lifetime Access to EOE</strong></li>
          <p>All lessons, updates, refinements, and future additions to EOE remain permanently available in your library.</p>

          <li style="margin-top: 15px;"><strong>✅ Downloadable Materials</strong></li>
          <p>Authentic workbooks, visual PDFs, and professional tools including the Essential Oil Conversion Calculator.</p>

          <li style="margin-top: 15px;"><strong>✅ Certificate of Attendance</strong></li>
          <p>Earn a formal Certificate of Attendance when you complete the Essential Oil Empress™ program.</p>

          <li style="margin-top: 15px;"><strong>✅ Special Live Bonus Q&A (Early 2026)</strong></li>
          <p>Included only in this edition:</p>
          <p>A live support session at the beginning of 2026 to help you integrate Dropsmart + EOE, refine your interpretations, and start the new year with total clarity.</p>
        </ul>

        <h2 style="margin-top: 20px;"><strong>Who This Is For</strong></h2>
        <ul class="benefits">
          <li style="margin-left: 20px;">• Aromatherapists who want clarity, confidence, and a modern, structured way of working</li>
          <li style="margin-left: 20px;">• Practitioners ready to stop second-guessing and make decisions with ease</li>
          <li style="margin-left: 20px;">• Educators who want to explain oils with more clarity, authority, and depth</li>
          <li style="margin-left: 20px;">• Professionals who want a dependable system and a deeper thinking method behind their practice</li>
          <li style="margin-left: 20px;">• Anyone seeking a complete professional upgrade for 2026 — grounded, elegant, and sustainable</li>
        </ul>
        <p>If you've been feeling behind, overwhelmed, or unsure, this bundle offers the structure, tools, and mindset shift that brings everything into focus.</p>

        <h2 style="margin-top: 20px;"><strong>100% Satisfaction Guarantee</strong></h2>
        <div class="guarantee-section">
          <div class="guarantee-image">
            <img src="@/assets/images/guarantee-100-satisfaction.png" alt="100% Satisfaction Guarantee" />
          </div>
          <div class="guarantee-text">
            <h3><strong>Dropsmart — 30-Day No-Questions-Asked Guarantee</strong></h3>
            <p>Your clarity and confidence matter.</p>
            <p>If you join the Dropsmart yearly plan and feel it isn't the right fit, you have a full 30 days to request a refund — no questions asked.</p>
            <p>Your membership will be cancelled and refunded in full.</p>
            <p>This guarantee exists so you can make your decision with ease, knowing you're fully supported.</p>
          </div>
        </div>

        <h2 style="margin-top: 20px;"><strong>100% Authenticity Guarantee</strong></h2>
        <div class="guarantee-section">
          <div class="guarantee-image">
            <img src="@/assets/images/guarantee-authentic.png" alt="100% Authenticity Guarantee" />
          </div>
          <div class="guarantee-text">
            <p>Everything you receive inside the Essential Oil Empress™ Program — every lesson, workbook, PDF, tool, and teaching — is 100% original material created by Melani.</p>
            <p>No recycled content.</p>
            <p>No second-hand interpretations.</p>
            <p>No filler.</p>
            <p>You're learning a modern, field-tested method built from real professional practice and designed to elevate the standards of aromatherapy.</p>
          </div>
        </div>

        <p style="margin-top: 20px;">If you want 2026 to be the year your work feels clearer, more grounded, and deeply aligned — the year you stop second-guessing and start trusting your inner authority — <strong>this is your invitation</strong>.</p>
        <p>One decision. Two premium gifts.</p>
        <p>And entry into a legacy program that may not return.</p>
        <p>Simply enter your information and complete your registration to secure your scholarship.</p>
      </b-col>
    </b-row>

    <h2 class="textMoneyback" v-if="this.routeName != 'GiftCard'">
      365-Day No-Questions-Asked Money-Back Guarantee
    </h2>
    <p class="text-riskFree" v-if="this.routeName != 'GiftCard'">
      You have <strong>365 days</strong> to ask for your money back. If you see that this is not for you, you can simply email us, and we will give your money back.
    </p>
  </div>
</template>

<style lang="scss">

ul.benefits {
  list-style: none;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.benefits li {
  margin-top: 10px;
  list-style: none;
  line-height: 28px;
  font-size: 18px;
}

.benefits p {
  margin-top: 10px;
  line-height: 24px;
  font-size: 16px;
  color: #545454;
}

.benefits ul {
  margin-top: 8px;
  margin-bottom: 8px;
}

.benefits ul li {
  font-size: 16px;
  margin-top: 5px;
}

h2 {
  font-size: 24px;
  color: #434343;
  margin-top: 20px;
  margin-bottom: 15px;
}

h3 {
  font-size: 24px;
  color: #434343;
  margin-top: 15px;
  margin-bottom: 10px;
}

.guarantee-section {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin: 20px 0;
  
  .guarantee-image {
    flex-shrink: 0;
    
    img {
      max-width: 150px;
      height: auto;
    }
  }
  
  .guarantee-text {
    flex: 1;
    
    p {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 10px;
      color: #434343;
    }
  }
}

@media (max-width: 768px) {
  .guarantee-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
    
    .guarantee-image {
      margin-bottom: 15px;
      
      img {
        max-width: 120px;
      }
    }
  }
}

p {
  color: #545454;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
}

.textMoneyback {
  color: #434343;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 19px;
  margin-top: 50px;
}

.text-riskFree {
  font-size: 18px;
  color: #434343;
  margin-bottom: 70px;
}

.testimonials {
  background: #f7f7f7;
  margin-bottom: 20px;
  padding: 40px 45px;
  img {
    margin-bottom: 25px;
    max-width: 80px;
  }
  p {
    color: #545454;
    font-size: 20px;
    line-height: 30px;
    img {
      margin: 0;
    }
  }
  .nomargin {
    margin: 0;
  }
  .testimonials-box {
    display: flex;
    align-items: center;
    img {
      align-self: center;
      margin-right: 30px;
    }
  }
  .testimonials-info {
    color: #545454;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    max-width: 300px;
    .testimonials-name {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 5px;
    }
  }
}
</style>

<script>

export default {
  name: "EOEmpressLeft",
  props: ['routeName'],
}
</script>

